import { useIntl } from 'react-intl';

import { AppIntl } from '@provider-portal/common/utils/translations';

/**
 * Wrapper function to fix typing
 * In future will also get additional functionality
 */
export function useAppIntl(): AppIntl {
  const intl = useIntl();

  return intl as AppIntl;
}
